import React from 'react';
import { string, number, arrayOf, shape, object } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { getNestedSubCategoryUrl, getStrictUrlWithParams, getSubCategoryUrl } from '../../../utils/url';
import { MP_CAROUSEL_CLICKED } from '../../../utils/biEvents/events/mixPanelEvents';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../utils/biEvents';
import { BQ_CLICKED_POPULAR_SERVICES_CAROUSEL } from '../../../utils/biEvents/events/bigQueryEvents';
import { TouchImage } from './TouchImage';

import styles from './index.module.scss';
import imageStyles from './image.module.scss';
import 'lazysizes';

const source = 'hplo_subcat_first_step';

const SubCategory = ({
    name,
    categorySlug,
    subCategorySlug,
    nestedSubCategorySlug,
    picture,
    image,
    index,
    strictUrl = '',
    params = {},
}) => {
    const { isTouch } = getContext();
    const pos = index + 1;
    const subCategoryNameKey = `logged_out_homepage.subcategory_carousel.${name}.sub`;
    const wrapperClassName = classNames(styles.wrapper, { [styles.touch]: isTouch });

    const routeOptions = { source, pos };

    const constructUrl = () => {
        if (strictUrl) {
            return getStrictUrlWithParams(strictUrl, params, routeOptions);
        }

        const queryParams = Object.keys(params).length > 0 ? params : undefined;

        return nestedSubCategorySlug
            ? getNestedSubCategoryUrl({ categorySlug, subCategorySlug, nestedSubCategorySlug, params: queryParams })
            : getSubCategoryUrl({ categorySlug, subCategorySlug, params: queryParams });
    };

    const urlToUse = constructUrl();

    const handleAfterChange = () => {
        sendMixPanelEvent({
            eventName: MP_CAROUSEL_CLICKED,
            params: { order: pos, element: translate(subCategoryNameKey) },
        });

        sendBigQueryEvent({
            eventName: BQ_CLICKED_POPULAR_SERVICES_CAROUSEL,
            params: { position: pos, elementName: name },
        });
    };

    return (
        <div className={wrapperClassName} onClick={handleAfterChange}>
            <a href={urlToUse} className={styles.inner}>
                <h3 className={styles.header}>
                    <I18n k={subCategoryNameKey} />
                </h3>

                {isTouch ? (
                    <TouchImage subCategoryNameKey={subCategoryNameKey} image={image} pos={pos} />
                ) : (
                    <picture>
                        {picture.map((img, index) => (
                            <source
                                key={index}
                                media={img.media}
                                srcSet={img.srcSet}
                                width={img.width}
                                height={img.height}
                            />
                        ))}
                        <img
                            className={classNames(imageStyles.image, 'lazyload')}
                            alt={translate(subCategoryNameKey)}
                            data-src={image.src}
                        />
                    </picture>
                )}
            </a>
        </div>
    );
};

SubCategory.propTypes = {
    name: string,
    categorySlug: string,
    subCategorySlug: string,
    nestedSubCategorySlug: string,
    strictUrl: string,
    params: object,
    picture: arrayOf(
        shape({
            media: string,
            srcSet: string,
        })
    ),
    image: shape({
        media: string,
        srcSet: string,
    }),
    index: number,
};

export default SubCategory;
